import type { FC, SyntheticEvent } from 'react'
import { ChevronIcon } from '@chegg-ui/horizon-icons'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import { CarouselCardWithImage } from '../utils'
import {
  CarouselContainer,
  CarouselImage,
  LeftArrowButton,
  RightArrowButton,
} from './styled'

interface ImageCarouselProps {
  currentCarouselCard: CarouselCardWithImage
  onLeftArrowClick: () => void
  onRightArrowClick: () => void
  imageClickEnabled: boolean
  onImageClick: () => void
  dataTestId?: string
}

export const ImageCarousel: FC<ImageCarouselProps> = ({
  currentCarouselCard,
  onLeftArrowClick,
  onRightArrowClick,
  imageClickEnabled,
  onImageClick,
  dataTestId,
}) => {
  const handleLeftArrowClick = (e: SyntheticEvent) => {
    onLeftArrowClick()
    e.stopPropagation()
  }

  const handleRightArrowClick = (e: SyntheticEvent) => {
    onRightArrowClick()
    e.stopPropagation()
  }

  return (
    <CarouselContainer
      imageClickEnabled={imageClickEnabled}
      data-test={dataTestId}
      onClick={() => imageClickEnabled && onImageClick()}
    >
      {/* todo - update alt with SEO requirements task */}
      <CarouselImage
        src={publicAssetUrl(currentCarouselCard.carouselImage)}
        alt={currentCarouselCard.content}
        height="100%"
        width="100%" /* Set an explicit width and height on image elements to reduce layout shifts and improve CLS */
      />
      <LeftArrowButton
        screenReaderOnlyText="carousel-left"
        onClick={handleLeftArrowClick}
      >
        <ChevronIcon pointing="left" color="white" />
      </LeftArrowButton>
      <RightArrowButton
        screenReaderOnlyText="carousel-right"
        onClick={handleRightArrowClick}
      >
        <ChevronIcon pointing="right" color="white" />
      </RightArrowButton>
    </CarouselContainer>
  )
}
